import { Button } from '@civilgrid/ui/components';
import type { ProjectFile } from './common';

interface Props {
  file: ProjectFile;
  deleteFile: (file: ProjectFile, type: 'files' | 'media') => Promise<void>;
  close: () => void;
  type: 'files' | 'media';
}

export default function DeleteFile({ file, deleteFile, close, type }: Props) {
  return (
    <div>
      <div className="my-4">Are you sure you want to permanently delete the selected files?</div>

      <div className="flex w-full justify-end gap-2">
        <Button variant="secondary" onClick={close} data-testid="project-file-delete-cancel">
          Cancel
        </Button>
        <Button
          data-testid="project-file-delete-confirm"
          onClick={() => {
            deleteFile(file, type);
            close();
          }}
        >
          Delete
        </Button>
      </div>
    </div>
  );
}
